import { render } from "./TvmServiceCoupons.vue?vue&type=template&id=342fc934&scoped=true"
import script from "./TvmServiceCoupons.js?vue&type=script&lang=js&external"
export * from "./TvmServiceCoupons.js?vue&type=script&lang=js&external"

import "./TvmServiceCoupons.vue?vue&type=style&index=0&id=342fc934&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-342fc934"]])

export default __exports__